<!--
BARRA SUPERIOR PARA FORMULARIOS DE LISTAS

CAMPO PARA PESQUISA E BOTAO PARA FILTRO AVANÇADO

    <bar-list
        :refresh-button="true"
        :new-button="true"
        :pdf-button="false"
        :xls-button="false"
        :filter-month="true"
        :filter-button="true"
        :adv-filters-object="advFilter"
        single-entity="Nota Fiscal"
        plural-entity="Notas Fiscais"
        :moreActions="moreActionsBarList"
        :incluirActions="incluirActionsBarList"
        @action="handleActionBarList"
        @search="search"
        @new="handleIncluir"
        @refresh="loadData"
        @filter="handleAdvancedFilter">
    </bar-list>

-->

<template>
  <section>

    <div class="row">
      <div class="col-md-12 col-12 mb-2 ml-2">
        <h4 class="def-title">{{ pluralEntity }}</h4>
      </div>
      <!-- pesquisa -->
      <div class="col-md-4 col-11 mx-auto mb-2" v-if="!hideSearch">
        <div class="input-group input-group-sm">
          <input class="form-control form-control-sm" id="search" type="text" :placeholder="'Pesquisar ' + pluralEntity"
            v-model="searchString" @keyup.enter="handlePesquisar" :title="titleSearch" data-toggle="tooltip"
            data-placement="top">
          <!-- <span v-if="!hideSearch" class="input-group-btn"> -->
          <span class="input-group-append">
            <button class="btn btn-sm btn-outline-secondary" style="margin-right: 5px" @click="handlePesquisar">
              <i class="fa fa-search" aria-hidden="true"></i>
            </button>
            <!-- botao mais filtros -->
            <button class="btn btn-sm btn-outline-secondary" title="Mais Filtros" v-if="filterButton"
              @click="clickFilter">
              <i class="fa fa-filter" aria-hidden="true"></i>
            </button>
            <!-- botao refresh -->
            <button class="btn btn-sm btn-outline-secondary" title="Atualizar Grid" v-if="refreshButton"
              @click="clickRefresh">
              <i class="fa fa-refresh" aria-hidden="true"></i>
            </button>
          </span>
          <!-- <span v-if="titleSearch" class="data-list-sm d-block w-100">{{ titleSearch }} </span> -->
        </div>
      </div>

      <!-- FILTRO DE MÊS -->
      <div class="col-md-3 col-12 mt-2 mt-md-0">
        <input-month :p-month="monthObj" v-if="filterMonth" @monthChange="handleMonthChange"></input-month>
      </div>
      <!--  -->

      <div class="col-md-5 col-12 ml-auto float-right my-3 mt-md-0">
        <!-- botao video -->
        <div class="btn-group float-right" v-if="videoButton">
          <v-button label="" :icon="videoIcon || 'fa-play'" :video="true" @click="clickVideo" title="Veja o vídeo" data-toggle="tooltip"
            data-placement="top"></v-button>
        </div>
        <!-- botao mais acoes -->
        <div class="btn-group float-right" v-if="moreActions && moreActions.length">
          <v-button label="Mais Ações" @click="clickAction" :actions="moreActions"></v-button>
        </div>
        <!-- botao novo -->
        <div class="btn-group float-right">
          <a href="javascript:void(0);" class="btn btn-sm nb-btdef btn-newitem"
            style="margin-right: 5px; min-width: 150px" v-if="newButton && !incluirActions" @click="clickNew"><i
              class="fa fa-plus" aria-hidden="true"></i> {{
                  singleEntity
              }} </a>
        </div>
        <div class="btn-group float-right" v-if="incluirActions">
          <v-button :label="singleEntity" icon="fa-plus" :nb-btdef="true" @click="clickAction"
            :actions="incluirActions"></v-button>
        </div>
        <div class="btn-group float-right" v-if="gerarEtiqueta">
          <button class="btn btn-sm nb-btdef mr-1" @click="clickPrint"><i class="fa fa-print"></i> Imprimir</button>
        </div>
      </div>

    </div>

    <!-- TELA DE FILTRO AVANÇADO -->
    <!--
    <bar-filter v-if="showAdvancedFilter" :adv-filters-object="advFiltersObject" @filter="handleApplyFilter"
      @close="showAdvancedFilter = false"></bar-filter>
    -->

    <filtro :showfiltro="showAdvancedFilter" :params="advFiltersObject" @change="handleApplyFilter"
      @cancel="showAdvancedFilter = false" />



    <!-- LISTA DOS FILTROS APLICADOS -->
    <div class="row mt-2" v-if="filterListActive.length > 0">
      <div class="col-md-12">
        <label class="lbl-edit">Filtros: </label>
        <div class="badgefilter badge-secondary" role="alert" v-for="(filter, index) in filterListActive" :key="index">
          <button type="button" class="close" data-dismiss="alert"
            @click="handleRemoveFilter(index, filter.filterIndex, filter.optionId)">
            x</button>
          <label class="mt-1">{{ filter.text }}</label>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div v-if="showVideo" class="guia-video" @click="showVideo = false">
        <div class="guia-video-content text-center d-flex justify-content-center align-items-center flex-column shadow">
          <div class="d-flex justify-content-end" style="width: 100%; margin-right: 10px">
            <button type="button" class="close" style="font-size: 2.5rem;" @click="showVideo = false"
              data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <iframe width="560" height="315" :src="urlVideo" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
            style="max-width: 800px"></iframe>
        </div>
      </div>
    </transition>

  </section>
</template>

<script>
import { SysVars } from '../main';
import BarFilter from '../components/bar-filter'
import Filtro from '../consultas/filtro'
import { apiDateORDS } from '../shared/api-functions'


export default {
  /*
  http://ruancarvalho.github.io/webdevacademy/ux/bootstrap-crud/view.html

  v-bind:class="{'is-active': variavelTrueFalse}"
  @click=""
  */
  props: {
    singleEntity: String,
    pluralEntity: String,
    newButton: Boolean,
    filterButton: Boolean,      //filtro avançado
    advFiltersObject: Object,    //objeto do filtro avançado
    pdfButton: Boolean,
    refreshButton: Boolean,
    xlsButton: Boolean,
    filterMonth: Boolean,
    fieldMonth: {
      type: String,
      default: 'data'
    },
    moreActions: Array,
    incluirActions: Array,
    urlHelp: String,
    monthFilter: Object,
    hideSearch: Boolean,
    titleSearch: String,
    gerarEtiqueta: Boolean,
    videoButton: Boolean,
    videoIcon: String,
    urlVideo: String,
    valueSearch: String,
  },

  components: {
    BarFilter,
    Filtro
  },

  data() {

    return {
      title: 'Clientes',
      searchString: this.valueSearch || '',
      marked: true,
      showAdvancedFilter: false,
      filterList: [],        //utilizado para exibicao em tela dos filtros aplicados
      urlQueryString: '',    //url com os filtros
      monthObj: {            //objeto utilizado pelo filtro de mes
        startDate: null,
        endDate: null
      },
      showVideo: false,
    }

  },

  computed: {
    filterListActive: function () {
      return this.filterList.filter(function (f) {
        return !f.removed
      })
    }
  },

  methods: {

    handleApplyFilter(filtro) {
      this.searchString = ''
      this.filterList = []
      let filter = {}
      filter.filterIndex = -1
      filter.text = "FILTROS AVANÇADOS"
      filter.optionId = null
      filter.removed = false
      this.filterList.push(filter)

      //emite o evento apply filter com a url do filtro
      this.$emit('advancedfilter', filtro)
      this.showAdvancedFilter = false

    },

    handleRemoveFilter(index, filterIndex, optionId) {
      //acionado quando usuário exclui algum filtro da lista de filtros ativos

      if (filterIndex == -1) {  //indica que o filtro é pelo campo de texto
        this.searchString = ''
        this.handlePesquisar()
        return
      }

      var obj = this.advFiltersObject[this.filterListActive[index].filterIndex]

      //desabilita o filtro para efetuar nova requisicao no servidor
      if (obj.filter.options) {
        for (let i = 0; i < obj.filter.options.length; i++) {
          if (obj.filter.options[i].id = optionId) {
            obj.filter.options[i].selected = false
          }
        }
      }

      //atualiza a url de filtro
      this.updateQueryString()

      //remove filtro aplicado da lista de filtros da tela
      this.filterListActive[index].removed = true

      //emite o evento apply filter com a url
      this.$emit('filter', this.urlQueryString)

    },

    handleMonthChange() {
      //evento que trata mudançao do filtro de periodo
      //o objeto monthObj foi atualizado com a data inicial e final

      this.searchString = ''
      this.filterList = []
      this.updateQueryString()  //atualiza a querystring

      //atualiza as datas selecionadas no objeto do componente pai
      if (this.monthFilter) {
        this.monthFilter.startDate = this.monthObj.startDate
        this.monthFilter.endDate = this.monthObj.endDate
        this.monthFilter.url = this.urlQueryString
      }

      //emite o evento filter com a url query string
      if (this.monthObj.startDate && this.monthObj.endDate)
        this.$emit('filter', this.urlQueryString, apiDateORDS(this.monthObj.startDate), apiDateORDS(this.monthObj.endDate, true))
      else
        this.$emit('filter', this.urlQueryString)

    },

    updateQueryString() {
      //monta a url com os filtros informado no filtro avançado e o mês selecionado

      var obj = {}

      var urlFilter = ''
      var arrUrl = []

      //monta a url com o mês selecionado
      if (this.filterMonth) {
        urlFilter = '{"' + this.fieldMonth + '":{"$between":[{"$date":"' + apiDateORDS(this.monthObj.startDate) + '"},{"$date":"' + apiDateORDS(this.monthObj.endDate, true) + '"}]}}'
        arrUrl.push(urlFilter)
      }

      //pesquisa todos os objetos do filtro avancado para montagem da url
      if (this.advFiltersObject) {
        for (let i = 0; i < this.advFiltersObject.length; i++) {
          obj = this.advFiltersObject[i]
          urlFilter = ''
          for (let x = 0; x < obj.filter.options.length; x++) {
            //monta a url do filtro com as opcoes selecionadas
            if (obj.filter.options[x].selected) {
              if (urlFilter != '') {
                urlFilter = urlFilter + ','
              }
              urlFilter = urlFilter + '{"' + obj.filter.fieldName + '":{"$eq":"' + obj.filter.options[x].id + '"}}'
            }
          }
          if (urlFilter != '') {
            urlFilter = '{"$or":[' + urlFilter + ']}'
            arrUrl.push(urlFilter)
          }
        }
      }

      this.urlQueryString = ''
      for (let i = 0; i < arrUrl.length; i++) {
        if (this.urlQueryString != '') {
          this.urlQueryString = this.urlQueryString + ','
        }
        this.urlQueryString = this.urlQueryString + arrUrl[i]
      }

      this.urlQueryString = '{"$and":[' + this.urlQueryString + ']}'

      //console.log(this.urlQueryString)

    },

    handlePesquisar() {
      //botao de pesquisa do campo de pesquisa pelo texto
      this.filterList = []

      var term = this.searchString.toUpperCase();
      // Se o termo parece um CNPJ formatado (contém simbolos e tem tamanho exato de 18 caracteres)
      // removemos a formatação para a pesquisa ser efetiva no banco (alfanumérico puro)
      if (term.length == 18 && (term.indexOf('.') >= 0 || term.indexOf('/') >= 0 || term.indexOf('-') >= 0)) {
        term = term.replace(/[^A-Z0-9]/g, '');
      }

      if (this.searchString != '') {
        let filter = {}
        filter.filterIndex = -1
        filter.text = term
        filter.optionId = null
        filter.removed = false
        this.filterList.push(filter)
      }
      this.urlQueryString = ''

      this.$emit('search', term)
    },

    clickAction(act) {
      this.$emit('action', act)
    },

    clickPrint() {
      this.$emit('print')
    },

    clickNew() {
      this.$emit('new')
    },

    clickFilter() {
      //abre o filtro avancado
      this.showAdvancedFilter = true
    },

    clickRefresh() {
      this.$emit('refresh')
    },

    clickVideo() {
      this.showVideo = true
    },

  },

  created() {
    var action = {}

    if (this.moreActions) {
      //adiciona as acoes no botao mais acoes
      if (this.pdfButton) {
        action = { label: 'Gerar PDF', action: 'pdf' }
        this.moreActions.push(action)
      }
      if (this.xlsButton) {
        action = { label: 'Exportar Planilha', action: 'xls' }
        this.moreActions.push(action)
      }
    }
  },

  mounted() {
    //atualiza as datas do filtro de mes no objeto FILTERMONTH do componente pai
    if (this.monthFilter) {
      this.updateQueryString()  //atualiza a querystring
      this.monthFilter.startDate = this.monthObj.startDate
      this.monthFilter.endDate = this.monthObj.endDate
      this.monthFilter.url = this.urlQueryString
    }

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })

  }

}
</script>

<style scoped>
.badgefilter {
  display: inline-block;
  padding: 5px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.70rem;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  opacity: .75;
}

.close {
  float: right;
  font-size: 1.0rem;
  color: #fff;
  text-shadow: 0 1px 0 #fff;
  opacity: 1;
  margin-left: 6px;
}
</style>





// WEBPACK FOOTER //
// src/components/bar-list.vue